import React from 'react';
// import logo from '../../images/20070-2-small.png';
import logo from '../../images/logoglobenew.png';
import 'react-toastify/dist/ReactToastify.css';
// import { useAuth0 } from '@auth0/auth0-react'
import LoginCard from './components/LoginCard';

const Signin = () => (
  <div>
    <div className="page-wrapper">
      <div className="container-fluid p-0">
        {/* <!-- login page start--> */}
        <div className="authentication-main">
          <div className="row">
            <div className="col-md-12">
              <div className="auth-innerright">
                <div className="authentication-box">
                  <div className="text-center">
                    <img src={logo} alt="" className="box-logo" />
                  </div>
                  <LoginCard />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- login page end--> */}
      </div>
    </div>
  </div>
);

export default Signin;
